import { render, staticRenderFns } from "./SymptomsList.vue?vue&type=template&id=1770774b&scoped=true"
import script from "./SymptomsList.vue?vue&type=script&lang=js"
export * from "./SymptomsList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1770774b",
  null
  
)

export default component.exports